/**
 * Sri Lanka Public Holidays and their impact on travel and attractions
 */

export interface Holiday {
  date: string; // 'YYYY-MM-DD' format
  name: string;
  fareImpact: string;
}

export const sriLankaHolidays: Holiday[] = [
  // 2025 Holidays (Official from Central Bank of Sri Lanka)
  { 
    date: "2025-01-13", 
    name: "Duruthu Full Moon Poya Day", 
    fareImpact: "Temple visits and religious observances increase demand around sacred sites." 
  },
  { 
    date: "2025-01-14", 
    name: "Tamil Thai Pongal Day", 
    fareImpact: "Festivals and family visits in Tamil-majority areas increase demand." 
  },
  { 
    date: "2025-02-04", 
    name: "Independence Day", 
    fareImpact: "Parades and national events cause traffic diversions and higher demand near venues." 
  },
  { 
    date: "2025-02-12", 
    name: "Navam Full Moon Poya Day", 
    fareImpact: "Temple visits and processions increase demand around religious sites." 
  },
  { 
    date: "2025-02-26", 
    name: "Maha Shivaratri Day", 
    fareImpact: "Hindu devotees travel to temples; increased demand in Hindu religious areas." 
  },
  { 
    date: "2025-03-13", 
    name: "Medin Full Moon Poya Day", 
    fareImpact: "Increased temple travel; expect higher demand near major Buddhist sites." 
  },
  { 
    date: "2025-03-31", 
    name: "Eid-ul-Fitr (Ramadan Festival Day)", 
    fareImpact: "Muslim community celebrations increase travel in Muslim-majority areas." 
  },
  { 
    date: "2025-04-12", 
    name: "Bak Full Moon Poya Day", 
    fareImpact: "Temple pilgrimages increase demand around religious sites." 
  },
  { 
    date: "2025-04-13", 
    name: "Day Prior to Sinhala & Tamil New Year", 
    fareImpact: "Peak intercity travel to hometowns; long-distance fares surge dramatically." 
  },
  { 
    date: "2025-04-14", 
    name: "Sinhala & Tamil New Year Day", 
    fareImpact: "City travel reduces; local short hops near events may be overpriced." 
  },
  { 
    date: "2025-04-15", 
    name: "Special Bank Holiday", 
    fareImpact: "Extended New Year celebrations; continued high travel demand to family gatherings." 
  },
  { 
    date: "2025-04-18", 
    name: "Good Friday", 
    fareImpact: "Christian community observances; increased travel to churches and family visits." 
  },
  { 
    date: "2025-05-01", 
    name: "World Workers' Day (May Day)", 
    fareImpact: "Rallies and closures cause congestion and surge pricing near city centers." 
  },
  { 
    date: "2025-05-12", 
    name: "Vesak Full Moon Poya Day", 
    fareImpact: "Largest Buddhist festival; massive crowds at temples and lantern displays nationwide." 
  },
  { 
    date: "2025-05-13", 
    name: "Day Following Vesak Full Moon Poya Day", 
    fareImpact: "Continued Vesak celebrations; temple visits and cultural events maintain high demand." 
  },
  { 
    date: "2025-06-07", 
    name: "Id-ul-Adha (Hajj Festival Day)", 
    fareImpact: "Muslim community celebrations and family gatherings increase travel demand." 
  },
  { 
    date: "2025-06-10", 
    name: "Poson Full Moon Poya Day", 
    fareImpact: "Major pilgrimage to Anuradhapura and Mihintale; very high intercity travel demand." 
  },
  { 
    date: "2025-07-10", 
    name: "Esala Full Moon Poya Day", 
    fareImpact: "Temple visits increase; Kandy Perahera season begins with high tourist activity." 
  },
  { 
    date: "2025-08-08", 
    name: "Nikini Full Moon Poya Day", 
    fareImpact: "Moderate temple travel; expect minor increases near religious areas." 
  },
  { 
    date: "2025-09-05", 
    name: "Milad-Un-Nabi (Birthday of Prophet Muhammad)", 
    fareImpact: "Muslim religious observances increase travel in Muslim communities." 
  },
  { 
    date: "2025-09-07", 
    name: "Binara Full Moon Poya Day", 
    fareImpact: "Temple travel and local events increase short-trip demand." 
  },
  { 
    date: "2025-10-06", 
    name: "Vap Full Moon Poya Day", 
    fareImpact: "End of monsoon season; temple events increase localized demand." 
  },
  { 
    date: "2025-10-20", 
    name: "Deepavali Festival Day", 
    fareImpact: "Hindu festival of lights; increased travel in Tamil and Hindu communities." 
  },
  { 
    date: "2025-11-05", 
    name: "Ill Full Moon Poya Day", 
    fareImpact: "Religious gatherings cause spot surges near temples." 
  },
  { 
    date: "2025-12-04", 
    name: "Unduvap Full Moon Poya Day", 
    fareImpact: "Pilgrimages increase intercity and local demand around temples." 
  },
  { 
    date: "2025-12-25", 
    name: "Christmas Day", 
    fareImpact: "Holiday outings and shopping increase demand in urban centers." 
  },

  // 2026 Holidays (Estimated - Poya days vary by lunar calendar)
  { 
    date: "2026-01-02", 
    name: "Duruthu Full Moon Poya Day", 
    fareImpact: "Temple visits and religious observances increase demand around sacred sites." 
  },
  { 
    date: "2026-01-14", 
    name: "Tamil Thai Pongal Day", 
    fareImpact: "Festivals and family visits in Tamil-majority areas increase demand." 
  },
  { 
    date: "2026-01-31", 
    name: "Navam Full Moon Poya Day", 
    fareImpact: "Temple visits and processions increase demand around religious sites." 
  },
  { 
    date: "2026-02-04", 
    name: "Independence Day", 
    fareImpact: "Parades and national events cause traffic diversions and higher demand near venues." 
  },
  { 
    date: "2026-03-02", 
    name: "Medin Full Moon Poya Day", 
    fareImpact: "Increased temple travel; expect higher demand near major Buddhist sites." 
  },
  { 
    date: "2026-03-20", 
    name: "Eid-ul-Fitr (Ramadan Festival Day)", 
    fareImpact: "Muslim community celebrations increase travel in Muslim-majority areas." 
  },
  { 
    date: "2026-04-01", 
    name: "Bak Full Moon Poya Day", 
    fareImpact: "Temple pilgrimages increase demand around religious sites." 
  },
  { 
    date: "2026-04-03", 
    name: "Good Friday", 
    fareImpact: "Christian community observances; increased travel to churches and family visits." 
  },
  { 
    date: "2026-04-13", 
    name: "Day Prior to Sinhala & Tamil New Year", 
    fareImpact: "Peak intercity travel to hometowns; long-distance fares surge dramatically." 
  },
  { 
    date: "2026-04-14", 
    name: "Sinhala & Tamil New Year Day", 
    fareImpact: "City travel reduces; local short hops near events may be overpriced." 
  },
  { 
    date: "2026-04-30", 
    name: "Vesak Full Moon Poya Day", 
    fareImpact: "Largest Buddhist festival; massive crowds at temples and lantern displays nationwide." 
  },
  { 
    date: "2026-05-01", 
    name: "World Workers' Day (May Day) / Day Following Vesak", 
    fareImpact: "May Day rallies and continued Vesak celebrations create very high demand." 
  },
  { 
    date: "2026-05-27", 
    name: "Id-ul-Adha (Hajj Festival Day)", 
    fareImpact: "Muslim community celebrations and family gatherings increase travel demand." 
  },
  { 
    date: "2026-05-30", 
    name: "Poson Full Moon Poya Day", 
    fareImpact: "Major pilgrimage to Anuradhapura and Mihintale; very high intercity travel demand." 
  },
  { 
    date: "2026-06-28", 
    name: "Esala Full Moon Poya Day", 
    fareImpact: "Temple visits increase; Kandy Perahera season begins with high tourist activity." 
  },
  { 
    date: "2026-07-27", 
    name: "Nikini Full Moon Poya Day", 
    fareImpact: "Moderate temple travel; expect minor increases near religious areas." 
  },
  { 
    date: "2026-08-25", 
    name: "Binara Full Moon Poya Day", 
    fareImpact: "Temple travel and local events increase short-trip demand." 
  },
  { 
    date: "2026-09-24", 
    name: "Vap Full Moon Poya Day", 
    fareImpact: "End of monsoon season; temple events increase localized demand." 
  },
  { 
    date: "2026-10-23", 
    name: "Ill Full Moon Poya Day", 
    fareImpact: "Religious gatherings cause spot surges near temples." 
  },
  { 
    date: "2026-11-09", 
    name: "Deepavali Festival Day", 
    fareImpact: "Hindu festival of lights; increased travel in Tamil and Hindu communities." 
  },
  { 
    date: "2026-11-22", 
    name: "Unduvap Full Moon Poya Day", 
    fareImpact: "Pilgrimages increase intercity and local demand around temples." 
  },
  { 
    date: "2026-12-25", 
    name: "Christmas Day", 
    fareImpact: "Holiday outings and shopping increase demand in urban centers." 
  }
];

/**
 * Check if a given date is a Sri Lankan holiday
 * @param date - Date object to check
 * @returns Holiday object if the date is a holiday, null otherwise
 */
export const getHolidayForDate = (date: Date): Holiday | null => {
  const dateStr = date.toISOString().split('T')[0];
  return sriLankaHolidays.find(h => h.date === dateStr) || null;
};

/**
 * Get all holidays within a date range
 * @param startDate - Start date of the range
 * @param endDate - End date of the range
 * @returns Array of holidays within the range
 */
export const getHolidaysInRange = (startDate: Date, endDate: Date): Holiday[] => {
  const start = startDate.toISOString().split('T')[0];
  const end = endDate.toISOString().split('T')[0];
  
  return sriLankaHolidays.filter(holiday => {
    return holiday.date >= start && holiday.date <= end;
  });
};

/**
 * Check if any day in the trip falls on a holiday
 * @param startDate - Trip start date
 * @param endDate - Trip end date
 * @returns True if any day is a holiday
 */
export const tripHasHolidays = (startDate: Date, endDate: Date): boolean => {
  return getHolidaysInRange(startDate, endDate).length > 0;
};

